<div id="wrapper">
  <div>
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
  </div>
  <div>
    <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
      (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
      (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
      (updateInitializeData)="this.initializeData()">
    </app-tab-nav>
  </div>
  <div class="allcont m-top-i">
    <div class=" p-b-20">
      <div class="container">
        <div class="">
          <div class="fulltitle  f-btitle autodef">
            <span><img width="100%" class="icon-iptv-2" src="/assets/images/icon_IPTV2.png"></span>
            <label class="clarotv2">Claro</label>
            <label class="tvmas2">tv+</label>
          </div>
        </div>
      </div>
    </div>
    <div class=" m-top lessm">
      <div class="container">
        <div class=" m-top-i">
          <div class="row hello2">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 roboto-l f-black text-justify pbotom">
              <span class="f-big less-f">
                ¿Qué es
                <label>Claro</label>
                <label>tv+</label>?</span><br /><br />
              <span class="f-reg-i f-mgray">
                Clarotv+ es una aplicación de video que permite a clientes suscritos al servicio de televisión acceder vía streaming a
                los canales seleccionados según su plan de entretenimiento. Consiste en canales de televisión lineal
                y contenido On Demand transaccional y gratuito.<br><br>
                La descarga de la aplicación es gratuita, sin embargo,
                el usuario tiene que tener una suscripción activa para poder autenticarse en la misma. Servicios
                adicionales disponibles via el App: Cloud DVR, Time Shift, Start Over.
              </span>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 text-center h-mtop n-pad">
              <img width="100%" src="../assets/images/clarotv_landing.png">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container lessm">
      <div class="">
        <div class="row hello ajus-padd1">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 center-img">
            <img class="img-divece-iptv" src="../assets/images/iptv_caja 1.png">
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 advertising">
            <div>
              <label class="tvmas3">Únete a la experiencia</label>
              <label class="clarotv3">&nbsp;Claro</label>
              <label class="tvmas3">tv+</label>
            </div>
            <div>
              ¡Disfruta todos tus canales favoritos en vivo desde tu Smartphone, Tablet o TV!
            </div>
            <div class="div-next">
              <div style="text-align: center;"><img src="../assets/images/icon_cajagratis.png"></div>
              <div>Llévate la primera caja inteligente <strong>GRATIS</strong>, y descarga tus aplicaciones favoritas
                de streaming donde quiera que estés.</div>
            </div>
            <div class="div-next">
              <div><img src="../assets/images/icon_streaming_.png"></div>
              <div>Con el asistente virtual Google Home y el control remoto, accedes la programación con tan solo
                hablarle.</div>
            </div>
            <div class="div-next">
              <div><img src="../assets/images/icon_premium_.png"></div>
              <div>Disfruta de servicios adicionales via el App: Cloud DVR, Time Shift, Start Over.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class=" m-top-p" id="1">
      <div class="container general-plan-box">
        <div class="plan-header-box">
          <div class=" f-big roboto-l f-black">
            Elige tu plan y vive la experiencia
            <label class="clarotv3">Claro</label>
            <label class="tvmas3">tv+</label>
          </div>
          <div class="see-full-guide">
            <a (click)="goToChannelList()" class="linkdefs">Ver Guía Completa&nbsp;&nbsp;<i class="fa fa-angle-right"
                aria-hidden="true"></i></a>
          </div>
        </div>
        <div>
          <app-plan-selection-iptv *ngIf="this.loadTokenSSO==true" 
            [checkIptv]="this.checkIptv">
          </app-plan-selection-iptv>
        </div>
      </div>
    </div>
    <div class=" m-top-i graybg">
      <div class="container">
        <div class=" m-top m-bott">
          <div class=" f-big roboto-l f-black">
            &#191;Necesitas Ayuda&#63;
          </div>
          <div class=" m-top-i">
            <div class="row refdef">
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <div class=" text-center">
                  <img width="100%" class="ref-icons" src="../assets/images/netflixicon1.png">
                </div>
                <div class=" f-black roboto-r f-reg text-center m-top">
                  <div class=" f-bmed roboto-b">
                    T&eacute;rminos y Condiciones
                  </div>
                  <div class=" m-top">
                    Consulta en esta sección los Términos & Condiciones para el servicio de <label
                      class="clarotv">Claro</label><label class="tvmas">tv+</label>
                    en la factura de Claro.
                    <br /><br />
                    <a href="/iptv_terms" class="linkdefs">Ver Detalle&nbsp;&nbsp;<i class="fa fa-angle-right"
                        aria-hidden="true"></i></a>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 hrefmtop">
                <div class=" text-center">
                  <img width="100%" class="ref-icons" src="../assets/images/ico_preguntasFrecuentes.png">
                </div>
                <div class=" f-black roboto-r f-reg text-center m-top">
                  <div class=" f-bmed roboto-b">
                    Preguntas Frecuentes
                  </div>
                  <div class=" m-top">
                    Te invitamos a que visites esta sección para que aclares algunas de las dudas
                    más comunes.
                    <br /><br />
                    <a href="/iptv_questions" ui-sref="iptv_questions" class="linkdefs">Ver
                      Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 hrefmtop">
                <div class=" text-center">
                  <img width="100%" class="ref-icons" src="../assets/images/netflixicon3.png">
                </div>
                <div class=" f-black roboto-r f-reg text-center m-top">
                  <div class=" f-bmed roboto-b">
                    Soporte T&eacute;cnico
                  </div>
                  <div class=" m-top">
                    ¿Cómo obtener apoyo técnico por parte de <label class="clarotv">Claro</label><label
                      class="tvmas">tv+</label> y/o Claro Puerto Rico si pagas
                    tu servicio de <a class="clarotv">Claro</a><a class="tvmas">tv+</a> a través de la factura de Claro?
                    <br /><br />
                    <a href="/iptv_support" class="linkdefs">Ver Detalle&nbsp;&nbsp;<i class="fa fa-angle-right"
                        aria-hidden="true"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
